module.exports = __webpack_public_path__ + "img/company_name@2x.95149bbf.png";